<script>
  import { searchTerm } from '../store.js';
</script>

<div class="simple-searchbox">
  <input
    bind:value={$searchTerm}
    id="searchModuleInput"
    type="search"
    class="search-input"
    placeholder="Search..."
  />
  <input type="submit" class="search-button" value="" aria-label="Submit" />
</div>
